import React from 'react';
import EvaluationPanelContents from 'components/EvaluationPanel/EvaluationPanelContents';

function EvaluationPanelSimple({ recipe, style }) {
    const results = recipe.nutrition_data;
    return <EvaluationPanelContents wholeDay={false} results={results} quickresults={false} opened={true} style={style} />;
}

export default EvaluationPanelSimple;
